import React from 'react';
import { Breakpoints, styled } from '@volkswagen-onehub/components-core';
import { useDisclaimer } from './DisclaimerContext';
import { CTAButton } from '../Button/CTAButton';
import { TextBox } from '../Box';
import {
  TextAppearance,
  TextSize,
  TextLineHeight,
} from '@vw-marketing/us-components';

export interface DisclaimerMarkerWrapperProps {
  disclaimerId: string;
  displayName: string;
}

const StyledDisclaimerMarker = styled.sup`
  display: inline-flex;
  box-sizing: border-box;
  background: rgb(223, 228, 232);
  border-radius: 100px;
  text-align: center;
  align-items: center;
  color: ${({ theme }) => theme.colors.content.primary};
  justify-content: center;
  cursor: pointer;
  min-width: 16px;
  min-height: auto;
  height: 16px;
  padding: 2px 5px;
  border: none;

  :hover {
    color: white;
    background: ${({ theme }) => theme.colors.button.primary.hover};
  }
`;

export const DisclaimerMarker: React.FC<DisclaimerMarkerWrapperProps> = ({
  disclaimerId,
  displayName,
}) => {
  const { openDisclaimer } = useDisclaimer();

  const handleClick = () => {
    openDisclaimer(disclaimerId, displayName);
  };

  return (
    <StyledDisclaimerMarker onClick={handleClick}>
      <TextBox
        tag='span'
        appearance={TextAppearance.copy200}
        style={{
          [Breakpoints.default]: {
            fontSize: TextSize.TextSize12,
            lineHeight: TextLineHeight.TextLineHeight36,
          },
        }}
      >
        {displayName}
      </TextBox>
    </StyledDisclaimerMarker>
  );
};
